import React, { useContext, useEffect, useState } from "react";
import queryString from "query-string";
import { emitMigrationModalAction, emitMigrationModalImpression, useExperiment, } from "@catchoftheday/analytics";
import { CustomerContext } from "@catchoftheday/customer";
import { cookies, getCookie } from "@catchoftheday/utilities";
import { COOKIE_ONEPASS_MIGRATION_MODAL_KEY, ONEPASS_MIGRATION_MODAL_EXPERIMENT, } from "../../../consts";
import { generateOnePassConsentUrl, isEligibleForOnePassMigration, } from "../../../utilities";
import { MigrationModal } from "../../pure/MigrationModal";
export const MigrationModalContainer = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentPathname, setCurrentPathname] = useState("/");
    const [currentQuery, setCurrentQuery] = useState({});
    const setCookie = () => {
        cookies.set(COOKIE_ONEPASS_MIGRATION_MODAL_KEY, "true", {
            expires: 30,
        });
    };
    const openModal = () => {
        emitMigrationModalImpression();
        setIsOpen(true);
    };
    const closeModal = () => {
        setCookie();
        emitMigrationModalAction("close");
        setIsOpen(false);
    };
    const handleProceed = () => {
        setCookie();
        emitMigrationModalAction("click");
    };
    const handleLearnMore = () => {
        setCookie();
    };
    const { variants: [experiment], loading: experimentLoading, } = useExperiment([ONEPASS_MIGRATION_MODAL_EXPERIMENT]);
    const { data: customer, loading: customerLoading } = useContext(CustomerContext);
    useEffect(() => {
        if (typeof globalThis !== "undefined") {
            setCurrentPathname(globalThis.location.pathname);
            setCurrentQuery(queryString.parse(globalThis.location.search));
        }
    }, []);
    useEffect(() => {
        const cookie = getCookie(COOKIE_ONEPASS_MIGRATION_MODAL_KEY, false);
        if (!experimentLoading &&
            experiment?.bucket === 1 &&
            !customerLoading &&
            isEligibleForOnePassMigration(customer) &&
            !cookie) {
            openModal();
        }
    }, [customer, customerLoading, experiment?.bucket, experimentLoading]);
    return (<MigrationModal isOpen={isOpen} ctaUrl={generateOnePassConsentUrl(currentPathname, currentQuery)} onClose={closeModal} onProceed={handleProceed} onLearnMore={handleLearnMore}/>);
};
